(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('OrderHistoryService', OrderHistoryService);

    OrderHistoryService.$inject = ['$http', 'API_URL'];

    function OrderHistoryService($http, API_URL) {

        var service = {
            loadBookedAreas: loadBookedAreas,
            loadBookedParts: loadBookedParts,
            deletePart: deletePart
        };

        return service;

        function loadBookedAreas() {
            return $http.get(API_URL + 'cart/areas');
        }

        function loadBookedParts() {
            return $http.get(API_URL + 'cart/history');
        }

        function deletePart(id) {
            return $http({
                method: 'DELETE',
                url: API_URL + '/cart/part?id=' +id
            });
        }
    }
})();
